export const ANALYTICS_KEY = 'G-HGGEYKESZE'